export const getTelegramWebApp = () => window.Telegram?.WebApp || null;

export const initTelegramWebApp = () => {
    const webApp = getTelegramWebApp();
    if (!webApp) return null;

    webApp.ready?.();
    webApp.expand?.();
    return webApp;
};

export const getSalesChannel = () => (
    getTelegramWebApp()?.initData ? 'telegram_mini_app' : 'website'
);
